module.exports = __webpack_public_path__ + "static/media/youtube.e1570b8f.png";